// api/mobileAuth.js
import axios from '@/api'

/**
 * 手机号验证码登录
 * @param {Object} data - 登录参数
 * @param {string} data.mobile - 手机号
 * @param {string} data.code - 验证码
 */
export const mobileLogin = (data) => {
  return axios.post('/auth/mobile/login', data)
    .then(res => res.data)
}
